// @TS-nocheck
import { useEffect, useState } from 'react'
import { string, object, number, array } from 'prop-types'
import classNames from 'classnames'
import { logger, validateAxiosResponse } from '@dmi-mch/utils'

import cssClasses from '@constants/cssClasses'
import { remapArtworkWithSponsorGalleries } from '@utils/catalog'
import { Separator } from '@components'
import Title from '@reusable-modules/HeadlineTitle'
// import CallToAction from '@reusable-modules/common/CallToAction'
// import ArtworkItem from '@modules/Catalog/Artworks/ArtworkItem'
import { Artworks as ArtworksService } from '@services'

const mID = 'otm-preview-catalog'

const CatalogPreview = props => {
  const autoDetect = props.grcpm_auto_detect_gallery === 'true'
  const galleryId = autoDetect ? props.pageMetaInfo.id : props.grcpm_related_gallery
  const sectorIds = props.grcpm_sector
  const [artworksList, setArtworksList] = useState([])

  useEffect(() => {
    let isUnmounted = false
    async function fetchData() {
      try {
        // Fetches the artworks of the gallery sorted according to the latest show.
        // And only shows the artworks of the latest show.
        const params = {
          galleryId,
          offset: 0,
          limit: 4,
          orderBy: 'show desc, position asc, name asc',
          descending: true,
          crmSectorGuids: sectorIds || []
        }

        const artworksResponse = await ArtworksService.getArtworks(params)

        if (validateAxiosResponse(artworksResponse) && !isUnmounted) {
          const items = remapArtworkWithSponsorGalleries(artworksResponse.data.items)
          let newItems = []

          if (items && items.length) {
            const lastShowId = items[0].showId
            newItems = items.filter(item => item.showId === lastShowId)
            newItems.forEach(i => delete i.sponsorGalleries) // eslint-disable-line no-param-reassign
          }

          setArtworksList(newItems)
        }
      } catch (e) {
        logger(e)
      }
    }
    fetchData()

    return () => {
      isUnmounted = true
    }
  }, [galleryId, sectorIds])

  return artworksList.length ? (
    <section id={props.id} className={classNames(mID, props.className, cssClasses.CMS_MODULE)}>
      <Separator />
      <Title hch-grp1_title_style='title_style_2' hch-grp1_header={props.grcpm_title} />
      <div>UIKIT Migration Catalog</div>
    </section>
  ) : null
}

CatalogPreview.propTypes = {
  grcpm_auto_detect_gallery: string,
  grcpm_call_to_action_label: string,
  grcpm_call_to_action_link: string,
  grcpm_title: string,
  grcpm_related_gallery: string,
  pageMetaInfo: object,
  className: string,
  id: number,
  grcpm_sector: array
}

export default CatalogPreview
